// extracted by mini-css-extract-plugin
export default {"root":"styles_root__tIdsC","title":"styles_title__G67PV","dataContainer":"styles_dataContainer__sCEH4","tableContainer":"styles_tableContainer__ADl7G"};